import generateActions from 'utils/actions';
import { navigate } from '@reach/router';
import Config from 'config';
import User from 'store/models/user';

export const LOGIN = generateActions('auth/LOGIN');
export const LOAD_CURRENT_USER = generateActions('auth/LOAD_CURRENT_USER');
export const SIGNUP = generateActions('auth/SIGNUP');
export const LOAD_CONFIRM = generateActions('auth/LOAD_CONFIRM');
export const LOAD_RECOVER = generateActions('auth/LOAD_RECOVER');
export const POST_RECOVER = generateActions('auth/POST_RECOVER');
export const LOGOUT = 'auth/LOGOUT';
export const SET_TOKEN = 'auth/SET_TOKEN';

/**
 * Request to the server to validate credentials
 * and receive a token.
 */
export function postLogin(email, password) {
  return {
    types: LOGIN,
    promise: {
      url: '/auth/login',
      method: 'post',
      data: {
        email,
        password
      },
    },
  };
}

/**
 * Creates a new user
 */
export function postSignup(name, email, password) {
  return {
    types: SIGNUP,
    promise: {
      url: '/auth/signup',
      method: 'post',
      data: {
        name,
        email,
        password
      },
    },
  };
}

/**
 * Create a new user, set a cookie with the token
 * and redirects the user to the discover.
 */
export function signup(name, email, password) {
  return (dispatch) => {
    return dispatch(postSignup(name, email, password))
      .then((response) => {
        if (response.payload.success) {
          localStorage.setItem(Config.cookies.token, response.payload.token);
          navigate('/app/discover');
        }
      });
  };
}

/**
 * Login the user, creates a cookie with the token
 * and redirects the user to the discover.
 */
export function login(email, password) {
  return (dispatch) => {
    return dispatch(postLogin(email, password))
      .then((response) => {
        localStorage.setItem(Config.cookies.token, response.payload.token);
        navigate('/app/discover');
      });
  };
}

/**
 * Tries to recover the password for the given email
 * @param {String} email 
 */
export function postRecover(email) {
  return {
    types: POST_RECOVER,
    promise: {
      url: '/auth/forgot',
      method: 'post',
      data: { email }
    }
  };
}

/**
 * Load a user by the given token, this is used to
 * recover password.
 * @param {String} token 
 */
export function loadRecover(token) {
  return {
    types: LOAD_RECOVER,
    promise: {
      url: `/auth/recover/${token}`,
    }
  };
}

/**
 * Loads a user by the given token, this is a used to
 * confirm email.
 * @param {String} token 
 */
export function loadConfirm(token) {
  return {
    types: LOAD_CONFIRM,
    promise: {
      url: `/auth/confirm/${token}`,
    }
  };
}

/**
 * Logouts the user from the system
 */
export function logout() {
  return (dispatch) => {
    localStorage.removeItem(Config.cookies.token);
    dispatch({ type: LOGOUT });
    navigate('/app/auth/sign-in');
  };
}

/**
 * Load the current user's profile
 */
export function loadCurrentUser() {
  return {
    types: LOAD_CURRENT_USER,
    promise: {
      url: '/users/current',
      reader: {
        model: User,
        root: 'user',
      },
    },
  };
}

export function setToken(token) {
  return {
    type: SET_TOKEN,
    payload: {
      token,
    },
  };
}